module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First, I would like to take a moment to thank everyone who helped me make this book (my first published work) a reality. Since I can remember, I’ve enjoyed countless hours reading books regarding this subject matter, but I never thought I would have the esteemed honor of authoring one myself. It is truly a dream come true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother, Sarah Bernardi, showed me how wonderful life can be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My father, Anthony Bernardi Sr., taught me the importance of working hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My patient and talented wife, Olivia Bernardi, is the best person I could ever dream of knowing and a great photographer, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The love of my three beautiful children, Evan, Owen and Gwen, helps to keep my spirit young and my imagination active.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary Ann Moran-Savakinus, director of the Lackawanna Historical Society and friend, thank you for your recommendation and for opening your mind to the paranormal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of my remaining family members and friends (you know who you are), without your love, support and encouragement, I would not be the person I am today. Thank you and God bless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My pets, Sugar and Avon, keep me in touch with nature and remind me to enjoy the simple pleasures life has to offer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lastly, I would like to thank all of the departed, lost and restless souls out there still clinging to this world. For without you, a book such as this could not be written. I have felt your cold touch and have heard your distant voices. Your tragic and haunting tales teach us to enjoy and appreciate life while we still have it and help us to imagine that there can be existence beyond death. May you someday find the strength of will and ability to pass on to a better state of being.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 66
// module chunks = 0